import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AnalyticsService } from 'services/analytics/analytics.service';
import { AppComponent } from './app.component';
import { environment } from '@environment/environment';

const routes: Routes = [
  { path: 'about_us', component: AppComponent },
  { path: 'how_it_works', component: AppComponent },
  { path: 'download', component: AppComponent },
  { path: 'discovery', component: AppComponent }
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, { useHash: environment.url.useHash, enableTracing: false, onSameUrlNavigation: 'reload' }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER, deps: [AnalyticsService], multi: true,
      useFactory: (analytics: AnalyticsService) => function () { return analytics.init(); },
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
